<router-outlet></router-outlet>
<div>
    <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" color="#00B9B3" type="triangle-skew-spin"
        [fullScreen]="true">
    </ngx-spinner>
</div>